import { useState } from 'react';
import { motion } from 'framer-motion';

type Bid = { id: string; tons: number; price: number; deadline: string; offers: Array<{companyId:string; price:number; cert?:string}> };

export function GovBidPanel() {
  const [tons, setTons] = useState(10);
  const [price, setPrice] = useState(70);
  const [deadline, setDeadline] = useState(new Date(Date.now()+3*86400000).toISOString().slice(0,16));
  const [rows, setRows] = useState<Bid[]>([]);

  const post = () => {
    const id = `bid-${Date.now()}`;
    setRows((r)=> [{ id, tons, price, deadline, offers: [] }, ...r]);
  };

  const offer = (id: string) => {
    const companyId = 'demoCo';
    const my = price-1;
    setRows((r)=> r.map(b => b.id===id? { ...b, offers:[{ companyId, price: my, cert:'NFT#1' }, ...b.offers] } : b));
  };

  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">Government Credit Bidding</div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 text-sm">
        <label className="flex items-center gap-2">Tons
          <input type="number" value={tons} onChange={(e)=>setTons(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-24"/>
        </label>
        <label className="flex items-center gap-2">€/t bid
          <input type="number" value={price} onChange={(e)=>setPrice(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-24"/>
        </label>
        <label className="flex items-center gap-2">Deadline
          <input type="datetime-local" value={deadline} onChange={(e)=>setDeadline(e.target.value)} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1"/>
        </label>
        <motion.button whileTap={{scale:0.97}} onClick={post} className="px-3 py-1 rounded border border-evat-neon text-evat-neon">Post Request</motion.button>
      </div>
      <div className="space-y-2 text-sm">
        {rows.map((b) => {
          const best = b.offers[0]?.price ?? b.price;
          const winProb = Math.min(0.95, Math.max(0.05, 1 - (best / (b.price+0.01))));
          return (
            <div key={b.id} className="border border-neutral-700 rounded p-2">
              <div className="flex items-center justify-between">
                <div className="text-neutral-300">{b.id} • {b.tons} t • €{b.price}/t • {new Date(b.deadline).toLocaleString()}</div>
                <motion.button whileTap={{scale:0.97}} onClick={()=>offer(b.id)} className="px-3 py-1 rounded border border-evat-gold text-evat-gold">Submit Offer</motion.button>
              </div>
              <div className="text-xs text-neutral-500">Win probability (demo): {(winProb*100).toFixed(0)}%</div>
              <div className="text-xs mt-1">Offers: {b.offers.map(o=> `${o.companyId} €${o.price}/t`).join(', ') || '-'}</div>
            </div>
          );
        })}
        {rows.length===0 && <div className="text-neutral-500 text-sm">No bids yet.</div>}
      </div>
    </div>
  );
}

export default GovBidPanel;



















